import { Component, OnInit } from '@angular/core'
import {
  trigger,
  state,
  style,
  stagger,
  keyframes,
  query,
  animate,
  transition
} from '@angular/animations'
import { NgAnimateScrollService } from 'ng-animate-scroll'
import { NavService } from '../../services/nav.service'
import { Router, NavigationEnd } from '@angular/router'

// import { from } from 'rxjs'

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        height: '100vh',
        width: '100vw',
      })),
      state('closed', style({
        opacity: 0,
        height: '0',
        width: '100vw',
      })),
      transition('open => closed', [
        animate('0.3s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ])
    ]),

    trigger('itemAnimation', [
      transition('* => *', [
        // Initially the all items are not visible
        query(':enter', style({ opacity: 0 }), { optional: true }),

        // Each card will appear sequentially with the delay of 300ms
        query(':enter', stagger('200ms', [
          animate('.5s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-50%)', offset: 0 }),
            style({ opacity: .5, transform: 'translateY(-10px) scale(1.1)', offset: 0.3 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
          ]))]), { optional: true }),

        // Cards will disappear sequentially with the delay of 300ms
        query(':leave', stagger('-200ms', [
          animate('200ms ease-out', keyframes([
            style({ opacity: 1, transform: 'scale(1.1)', offset: 0 }),
            style({ opacity: .5, transform: 'scale(.5)', offset: 0.3 }),
            style({ opacity: 0, transform: 'scale(0)', offset: 1 }),
          ]))]), { optional: true })
      ])
    ]),
    trigger('fadeInSideNav', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.5s', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('0.5s', style({ opacity: 0 }))
      ])
    ]),
  ]
})
export class NavComponent implements OnInit {
  public hideSideNav: boolean = false
  public loaded: boolean = false
  public isOpen: boolean = false
  public menuItems = [
    {
      'title': 'Intro',
      'slug': 'intro',
      'isActive': true
    }, 
    {
      'title': 'About',
      'slug': 'about',
      'isActive': false
    }, 
    {
      'title': 'Projects',
      'slug': 'project-list',
      'isActive': false
    },
    {
      'title': 'Network',
      'slug': 'network',
      'isActive': false
    },
    {
      'title': 'Contact',
      'slug': 'contact',
      'isActive': false
    }
  ]

  public loadMenuItems: boolean = false
  public menuIndex = this.menuItems.length

  public activeNavSlug: string = 'intro'

  constructor(
    private animateScrollService: NgAnimateScrollService,
    private navService: NavService,
    private router: Router
  ) {}

  ngOnInit() {
    this.navService.currentActiveNavItem.subscribe(slug => {
      this.activeNavSlug = slug

      setTimeout(() => {
        this.loaded = true
      }, 1800)

      this.router.events.subscribe(val => {
        if(val instanceof NavigationEnd) {
          if(val.url.indexOf('project') !== -1) {
            this.hideSideNav = false 
          } else {
            this.hideSideNav = true
          }
        }
      })
    })
  }

  openMenuSlider() {
    this.isOpen = true

    setTimeout(() => {
      this.loadMenuItems = true
    }, 800)
  }

  closeMenuSlider() {
    this.loadMenuItems = false
    setTimeout(() => {
      this.isOpen = false
    }, 400)
  }

  scrollTo(target, index) {
    this.animateScrollService.scrollToElement(`${target}-target`, 1000)

    for(let item of this.menuItems) {
      item.isActive = false
    }

    setTimeout(() => {
      this.menuItems[index].isActive = true
    }, 30)
  }

  scrollToAndCloseNav(target, index) {
    this.animateScrollService.scrollToElement(target)
    this.closeMenuSlider()
  }

  changeActiveNav(index) {
    for(let item of this.menuItems) {
      item.isActive = false
    }

    setTimeout(() => {
      this.menuItems[index].isActive = true
    }, 20)
  }

  goHome() {    
    this.router.navigate(['/'])
  }
}
